export type AllotmentNodeDTO = {
  id: number;
  name: string;
};

export const TYPE_EPCM = 'epcm';
export const TYPE_RE2020 = 're2020';
export const TYPE_NOOCO = 'nooco';
export const TYPE_EXPLOITATION = 'exploitation';
export const TYPE_AIRPORT = 'airport';
export const TYPE_DATACENTER = 'datacenter';
export const TYPE_OUTDOOR = 'outdoor';
export const TYPE_RENOVATION = 'renovation';
export const TYPE_MAPPINGREF = 'mappingRef';
export const TYPE_PROTOTYPE = 'prototype';
export const TYPE_BBCA = 'bbca';
export const TYPE_SIMULATOR = 'quickSim';
export const TYPE_GLOBAL_MONITORING = 'globalMonitoring';

export const TEMPLATE_TYPE_NAME = {
  EPCM: TYPE_EPCM,
  RE2020: TYPE_RE2020,
  NOOCO: TYPE_NOOCO,
  EXPLOITATION: TYPE_EXPLOITATION,
  AIRPORT: TYPE_AIRPORT,
  DATACENTER: TYPE_DATACENTER,
  OUTDOOR: TYPE_OUTDOOR,
  RENOVATION: TYPE_RENOVATION,
  MAPPINGREF: TYPE_MAPPINGREF,
  PROTOTYPE: TYPE_PROTOTYPE,
  BBCA: TYPE_BBCA,
  SIMULATOR: TYPE_SIMULATOR,
  GLOBAL_MONITORING: TYPE_GLOBAL_MONITORING,
};
